import { render, staticRenderFns } from "./RolesTable.vue?vue&type=template&id=1e309e3d&scoped=true&"
import script from "./RolesTable.vue?vue&type=script&lang=js&"
export * from "./RolesTable.vue?vue&type=script&lang=js&"
import style0 from "./RolesTable.vue?vue&type=style&index=0&id=1e309e3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e309e3d",
  null
  
)

export default component.exports